import { render, staticRenderFns } from "./LockPermissions.vue?vue&type=template&id=ab7f75be&scoped=true"
import script from "./LockPermissions.vue?vue&type=script&lang=js"
export * from "./LockPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7f75be",
  null
  
)

export default component.exports